import { MenuPoint } from '@agilox/ui-common';
import { myMenuPoints } from './my-menupoints.const';

export const desktopMenuPoints: Array<MenuPoint> = [
	myMenuPoints.dashboard,
	myMenuPoints.fleet,
	myMenuPoints.release_notes,
	myMenuPoints.maas,
	myMenuPoints.settings,
	myMenuPoints.help,
	myMenuPoints.logout,
];
